import { render, staticRenderFns } from "./OptionInfo.vue?vue&type=template&id=df6c6c32&scoped=true&"
import script from "./OptionInfo.vue?vue&type=script&lang=js&"
export * from "./OptionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6c6c32",
  null
  
)

export default component.exports